










import {Vue, Component, Model, Prop} from 'vue-property-decorator';
@Component
export default class PageFormselect extends Vue {
  @Prop({required: true}) private data!: object;
  @Prop({required: true}) private selectValue!: string | number;
  @Prop({required: true}) private selectKey!: string | number;
  @Prop({required: true}) private selectDisplayName!: string;
  @Prop({required: false}) private disabled?: boolean;

  get isDisabled(): boolean {
    return this.disabled || false;
  }

  @Model('change') readonly currentValue!: string;
  private valueChanged(e: Event) {
    this.$emit('change', (e.target as HTMLSelectElement).value, e);
  }
}
